import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { subscribe } from '@/service/vip';
import NextImage from '@/components/NextImage';
import { getPrivacyPolicy } from '@/utils/common';

export default function SignupPopupMain({ changeStatu }: any) {
    const { useLang, useState, useRouter, isMobile, Link, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('applandingpage');
    const [input, setInput] = useState('');
    const [check, setCheck] = useState(false);
    const [showMsg, setShowMsg] = useState('');

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const handleInputChange = (v: any) => {
        setInput(v.target.value);
        if (!emailRegex.test(input)) {
            return setShowMsg('');
        }
    };

    const handleCheck = () => {
        setCheck(!check);
        if (!check && showMsg) {
            setShowMsg('');
        }
        if (check && !showMsg) {
            setShowMsg(t('check'));
        }
    };

    const handleSubmit = async () => {
        if (!input) {
            return setShowMsg(t('tip'));
        }
        if (!emailRegex.test(input)) {
            return setShowMsg(t('tip'));
        }
        if (!check) {
            return setShowMsg(t('check'));
        }
        setShowMsg('');
        try {
            const res = await subscribe(input.trim(), locale, 'APP_BANNER_SUB', {
                sector_name: t('title'),
                entry_position: 2,
            });
            if (res?.code === '0') {
                setInput('');
                setShowMsg('');
                changeStatu(2);
            } else {
                setShowMsg(res?.message);
                console.error(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('btn'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        } catch (e) {
            console.error(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('btn'),
                status: 'fail',
                tag: 'Agree',
            });
        }
    };

    return (
        <div className={`signup-popup-main ${css['signup-popup-main']} ${isMobile ? 'signup-popup-main-h5' : 'signup-popup-main-pc'}`}>
            <div className="banner">
                <NextImage src={require(`@publicLocal/app-landing-page/${isMobile ? 'h5' : 'pc'}/1.jpg`)} alt={t('banner')} />
                <p className="banner-text">{t('banner')}</p>
            </div>
            <div className="popup-content">
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
                <div className="control">
                    <input type="text" className="input" value={input} onChange={handleInputChange} placeholder={t('placeholder')} />
                    <button className="subscribe" onClick={handleSubmit}>
                        {t('btn')}
                    </button>
                </div>
                {showMsg && <p className="error-msg">{showMsg}</p>}
                <div className="agreement">
                    <input type="checkbox" className="agree-check" id="agree" checked={check} onChange={handleCheck} />
                    <label htmlFor="agree" className="agree-label">
                        {t.rich('agree', {
                            a1: (text: string) => (
                                <Link className="link" href={getPrivacyPolicy(locale)}>
                                    {text}
                                </Link>
                            ),
                            a2: (text: string) => (
                                <Link className="link" href={`https://${locale}.ecoflow.com/policies/terms-of-service`}>
                                    {text}
                                </Link>
                            ),
                        })}
                    </label>
                </div>
            </div>
        </div>
    );
}
